<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <div class="box">
          <div class="box-header">
            <h3 class="box-title">廣告列表</h3>
          </div>
          <!-- /.box-header -->
          <div class="box-body">
            <ad-table />
            <!-- /.box-body -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import $ from 'jquery'
// Require needed datatables modules
import 'datatables.net'
import 'datatables.net-bs'
import adTableTemp from './Temp/BrandAdTableTemp.vue'
export default {
  name: 'Tables',
  data () {
    return {
      tableIndex: 1,
      show: {
        menu: false,
        menuDetail: false
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      $('#example1').DataTable({
        'paging': false,
        'ordering': false,
        'pagingType': 'numbers',
        'info': false,
        'lengthChange': false,
        'filter': false
      })
    })
  },
  methods: {
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    }
  },
  components: {
    'ad-table': adTableTemp
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    }
  }
}
</script>



// WEBPACK FOOTER //
// BrandAdTable.vue?489ce3c1